import { BolStop } from '../types/bolTypes';
import { getAbbrSortCode, sealFromSortCode } from './bolUtils';

/**
 * BolFormEditor（非交接）与 BolHandoverFormEditor（交接）共享的字段常量与表单工具
 */

/** 保存状态提示 */
export enum SaveStatus {
    Success = 'success',
    Error = 'error',
}

export const SHIP_TO_FIELD_BASES = ['shipToAddress', 'shipToCityStateZipcode', 'shipToContactName', 'shipToContactPhoneNumber'] as const;
export type ShipToFieldBase = (typeof SHIP_TO_FIELD_BASES)[number];
export const SHIP_TO_REQUIRED_FIELDS: ShipToFieldBase[] = [...SHIP_TO_FIELD_BASES];

// 司机名称/电话不在编辑范围内：司机1与司机2均实时读 tms_task_ext（司机1在扩展行缺失时回退 tms_task 老列），
// 不读 BOL 快照列；后端已移除对应的 BOL 更新入参，这里同步去掉输入框与必填校验
export const CARRIER_FIELD_BASES = ['trailerNumber', 'licensePlate', 'proNumber'] as const;
export type CarrierFieldBase = (typeof CARRIER_FIELD_BASES)[number];
export const CARRIER_REQUIRED_FIELDS: CarrierFieldBase[] = ['trailerNumber', 'licensePlate'];

export const CARRIER_FIELD_LABEL_KEYS: Record<CarrierFieldBase, string> = {
    trailerNumber: 'tms.task.bol.trailerNumber',
    licensePlate: 'tms.task.bol.licensePlate',
    proNumber: 'tms.task.bol.proNumber'
};
export const CARRIER_FIELD_PLACEHOLDER_KEYS: Record<CarrierFieldBase, string> = {
    trailerNumber: 'tms.task.bol.placeholderTrailerNumber',
    licensePlate: 'tms.task.bol.placeholderLicensePlate',
    proNumber: 'tms.task.bol.placeholderProNumber'
};

export const buildShipToFormName = (fieldBase: ShipToFieldBase, stopIndex: number) => `${fieldBase}_${stopIndex}_to`;
export const buildShipToFieldMeta = (fieldBase: ShipToFieldBase, stopIndex: number) => ({
    formName: buildShipToFormName(fieldBase, stopIndex),
    fieldKey: fieldBase as keyof BolStop
});
export const buildStopFormFields = (stopIndex: number) => ({
    address: buildShipToFieldMeta(SHIP_TO_FIELD_BASES[0], stopIndex),
    cityStateZip: buildShipToFieldMeta(SHIP_TO_FIELD_BASES[1], stopIndex),
    contactName: buildShipToFieldMeta(SHIP_TO_FIELD_BASES[2], stopIndex),
    contactPhone: buildShipToFieldMeta(SHIP_TO_FIELD_BASES[3], stopIndex)
});

export const buildSealFieldName = (stopIndex: number) => `sealNumber_${stopIndex}`;

export interface SealSegment {
    stopIndex: number;
    label: string;
    sealNumber: string;
}

/** 封签段列表；始发站取值规则见 sealFromSortCode（三方任务取上一段目的站） */
export const getSealSegments = (stops: BolStop[], taskType?: number): SealSegment[] => {
    if (stops.length <= 1) return [];

    return stops.slice(1).map((stop, index) => {
        const from = sealFromSortCode(stops, taskType, index + 1);
        const to = getAbbrSortCode(stops[index + 1]?.shipToSortCode);
        return {
            stopIndex: index + 1,
            // 始发-终到；无终到站（如 DHLe 交接只有始发站）时只显示始发，不带 "-"
            label: to ? `${from}-${to}` : from,
            sealNumber: stop.sealNumber || ''
        };
    });
};
